<template>
  

  <!-- edit user -->
  
    
    <div class="column center" style="width: 100%; position: relative;">
        
      <p @click="copyText(item.id)" style="position: absolute; left: 10px; top: 0px;" class="mini pointer click">ID {{ item.id }}</p>
      <div class="row ch" style="position: absolute; right: 10px; top: 0px;">
        <img style="height: 10px;" v-if="!item.provider || item.provider == 0" src="/images/icons/providers/mono/email.svg">
        <img style="height: 10px;" v-if="item.provider == 1" src="/images/icons/providers/mono/google.svg">
        <img style="height: 10px;" v-if="item.provider == 2" src="/images/icons/providers/mono/apple.svg">        
        <img style="height: 10px;" v-if="item.provider == 3" src="/images/icons/providers/mono/private.svg">

        <p @click="copyText(item.email)" class="mini pointer click ml2 mr4">{{ item.email }}</p>
        
        <svg class="pointer click" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_219_1313)"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.0002 1.83333C16.0629 1.83333 20.1668 5.93725 20.1668 11C20.1668 16.0627 16.0629 20.1667 11.0002 20.1667C5.93741 20.1667 1.8335 16.0627 1.8335 11C1.8335 5.93725 5.93741 1.83333 11.0002 1.83333ZM15.1252 9.625C14.7605 9.625 14.4108 9.76986 14.1529 10.0277C13.895 10.2856 13.7502 10.6353 13.7502 11C13.7502 11.3647 13.895 11.7144 14.1529 11.9723C14.4108 12.2301 14.7605 12.375 15.1252 12.375C15.4898 12.375 15.8396 12.2301 16.0974 11.9723C16.3553 11.7144 16.5002 11.3647 16.5002 11C16.5002 10.6353 16.3553 10.2856 16.0974 10.0277C15.8396 9.76986 15.4898 9.625 15.1252 9.625ZM11.0002 9.625C10.6355 9.625 10.2858 9.76986 10.0279 10.0277C9.77003 10.2856 9.62516 10.6353 9.62516 11C9.62516 11.3647 9.77003 11.7144 10.0279 11.9723C10.2858 12.2301 10.6355 12.375 11.0002 12.375C11.3648 12.375 11.7146 12.2301 11.9724 11.9723C12.2303 11.7144 12.3752 11.3647 12.3752 11C12.3752 10.6353 12.2303 10.2856 11.9724 10.0277C11.7146 9.76986 11.3648 9.625 11.0002 9.625ZM6.87516 9.625C6.51049 9.625 6.16075 9.76986 5.90289 10.0277C5.64503 10.2856 5.50016 10.6353 5.50016 11C5.50016 11.3647 5.64503 11.7144 5.90289 11.9723C6.16075 12.2301 6.51049 12.375 6.87516 12.375C7.23984 12.375 7.58957 12.2301 7.84743 11.9723C8.1053 11.7144 8.25016 11.3647 8.25016 11C8.25016 10.6353 8.1053 10.2856 7.84743 10.0277C7.58957 9.76986 7.23984 9.625 6.87516 9.625Z" fill="white" fill-opacity="0.2"/></g><defs><clipPath id="clip0_219_1313"><rect width="22" height="22" fill="white"/></clipPath></defs></svg>
      
      </div>
      

      <br>
      <!-- image -->
      <div class="avatar column center pointer click" v-upload.images="uploadAvatar" :style="{background: `url(${item.image || ''}) no-repeat center center`}" style="background-size: cover" >
        <svg v-if="!item.image" width="44" height="34" viewBox="0 0 44 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M42.5722 28.0829C42.5722 29.5982 42.1902 30.7816 41.4261 31.6331C40.6746 32.4972 39.4848 32.9293 37.8565 32.9293H5.31682C3.96413 32.9293 2.9684 32.5536 2.32963 31.8022C1.70339 31.0634 1.32764 29.905 1.20239 28.3271L8.30401 21.8088C8.67976 21.4457 9.06177 21.1764 9.45004 21.0011C9.85084 20.8258 10.2767 20.7381 10.7276 20.7381C11.191 20.7381 11.6294 20.832 12.0427 21.0199C12.4685 21.2077 12.8819 21.477 13.2827 21.8276L16.8147 25.0773L25.3629 17.432C25.8138 17.0438 26.271 16.7495 26.7344 16.5492C27.1978 16.3488 27.6926 16.2486 28.2186 16.2486C28.7697 16.2486 29.2832 16.3551 29.7592 16.568C30.2477 16.7683 30.7111 17.0689 31.1494 17.4696L42.5722 28.0829ZM13.8087 17.2818C12.9946 17.2818 12.2494 17.0877 11.573 16.6994C10.9092 16.2987 10.3769 15.7602 9.97609 15.084C9.57529 14.4077 9.37489 13.6626 9.37489 12.8486C9.37489 12.0471 9.57529 11.3083 9.97609 10.632C10.3769 9.9558 10.9092 9.41731 11.573 9.01657C12.2494 8.61584 12.9946 8.41547 13.8087 8.41547C14.6228 8.41547 15.3618 8.61584 16.0256 9.01657C16.6894 9.41731 17.2217 9.9558 17.6225 10.632C18.0233 11.3083 18.2237 12.0471 18.2237 12.8486C18.2237 13.6626 18.0233 14.4077 17.6225 15.084C17.2217 15.7602 16.6894 16.2987 16.0256 16.6994C15.3618 17.0877 14.6228 17.2818 13.8087 17.2818ZM5.52348 34C3.69485 34 2.31711 33.5366 1.39026 32.6099C0.463422 31.6958 0 30.337 0 28.5337V5.48508C0 3.66924 0.463422 2.30424 1.39026 1.39006C2.31711 0.463352 3.69485 0 5.52348 0H38.4577C40.2989 0 41.6829 0.469613 42.6097 1.40884C43.5366 2.33554 44 3.69429 44 5.48508V28.5337C44 30.337 43.5366 31.6958 42.6097 32.6099C41.6829 33.5366 40.2989 34 38.4577 34H5.52348ZM5.57985 31.6895H38.4202C39.4597 31.6895 40.2613 31.414 40.8249 30.863C41.3886 30.312 41.6704 29.4917 41.6704 28.4022V5.61657C41.6704 4.52707 41.3886 3.70681 40.8249 3.1558C40.2613 2.59227 39.4597 2.3105 38.4202 2.3105H5.57985C4.51523 2.3105 3.70111 2.59227 3.13749 3.1558C2.58639 3.70681 2.31085 4.52707 2.31085 5.61657V28.4022C2.31085 29.4917 2.58639 30.312 3.13749 30.863C3.70111 31.414 4.51523 31.6895 5.57985 31.6895Z" fill="white" fill-opacity="0.6"/></svg>
      </div>
      
      <div class="column center" style="position: relative;">

        <!-- username -->
        <p class="t3" @keydown.enter.prevent="''" title="Username" v-if="item.username" @blur="item.username = $event.target.innerText; update('username', item.username)" >{{item.username.startsWith('#') ? 'No username' : `@${item.username}`}}</p>        
        
        <!-- title -->
        <h1  @keydown.enter.prevent="''" style="font-size: 38px; font-weight: 700;"  @blur="item.name = $event.target.innerText; update('name', item.name)">{{ item.name || 'No name'}}</h1>
        <br>
        <!-- location -->
        <div class="row mb4" v-if="item.city">
          <img style="width: 16px; height: 16px; margin-right: 8px; margin-top: 2px;" :src="`/images/icons/flags/round/${item.country}.svg`" alt="">
          <p class="desc">{{ item.city }}, {{ item.state || item.country }}</p>
        </div>        
      </div>
      
      <div class="tabs">
        <p class="tab" :class="{active: page =='main'}" @click="page = 'main'">General</p>
        <p class="tab" :class="{active: page =='assets'}" @click="page = 'assets'">Assets</p>
        <!-- <p class="tab" :class="{active: page =='history'}" @click="page = 'history'">History</p> -->
        <p class="tab" v-if="private" :class="{active: page =='api'}" @click="page = 'api'">API</p>
        <p class="tab" v-if="!private" :class="{active: page =='support'}" @click="page = 'support'">Support</p>
        <!-- <router-link class="tab" :to="{name: 'accounts/page/assets'}">Assets</router-link>
        <router-link class="tab" :to="{name: 'accounts/page/history'}">History</router-link>
        <router-link class="tab" :to="{name: 'accounts/page/support'}">Support</router-link>         -->
      </div>

      <br>


      
      <div class="column center" v-if="page == 'main' && !private">
        <!-- <div class="row">
          <Switch style="margin-right: 20px;" v-model="item.active" @update="update('active', item.active)">Active</Switch>
          <Switch style="margin-right: 20px;" v-model="item.verified" @update="update('verified', item.verified)">Verified</Switch>
          <Switch v-model="item.kyc" @update="update('kyc', item.kyc)">KYC</Switch>
        </div> -->

        <br>

        <div class="column left padding">
          <table>
            <tr v-for="(line, index) in fieldsList" :key="index">
              <td>{{ tools.title(line.k) }}</td>              
              <td v-if="line.type == 'bool'"><Switch style="margin-right: 20px;" v-model="line.v" @update="update(line.k, line.v)"></Switch></td>
              <td v-if="line.type == 'string'"> <input class="w300" type="text" v-model="line.v" @input="update(line.k, line.v)"> </td>
              <td v-if="line.type == 'provider'" class="left" style="padding-left: 0;"> 
                <div class="tabs">
                  <p class="tab" :class="{active: line.v == pro.id}" @click="changeProvider(pro.id)" v-for="(pro, ind) in [{id:0, name:'Email'},{id:1, name:'Google'},{id:2, name:'Apple'},{id:3, name:'Private'}]" :key="ind">{{ pro.name }}</p>  
                  </div>
              </td>    
              
              <td v-if="line.type == 'geoid'"> 
                {{ item.geoid }} <City v-if="item.country" :country="item.country" :city="item.city" :state="item.state" />
              </td>
            </tr>

            <tr v-if="!item.provider">
              <td>New password</td>
              <td>
                <input class="w300" type="text" placeholder="pass" v-model="newpass" @input="update('pass', newpass)"> 
              </td>
            </tr>
          </table>
          
        </div>
      </div>

      <div v-if="page == 'api' && private">
        <AccountPageAPI :uid="user.id"></AccountPageAPI>
      </div>
      
      <!-- private -->
      <div v-if="page == '1api' && private">

        <div>   
          <h4>API Token</h4>       
          <p class="mini">Click to copy</p>
          <br>
          <div v-if="apitoken" class="click pointer" @click="copyText(apitoken)" style="padding: 20px 30px; background-color: var(--g05);">
            <p class="demi" >{{ apitoken }}</p>
          </div>          
        </div>
        <br>

        <div>
          <h4>Access</h4>
          <br>
        <table>
          <tr class="bold">
            <td>Category</td>            
            <td>Create</td>
            <td>Get</td>
            <td>Prices</td>            
            <td>Brands</td>
          </tr>
          <tr v-for="(root, index) in roots.all" :key="index" class="hover">
            <td > <span class="bold" :style="{color: root.active ? 'var(--primary)':'var(--g3)'}">• </span>{{ root.title }}</td>
            <td class="ccc"><Switch v-model="item.meta[`private_${root.id}_create`]" @update="updateAccess('create', item.meta[`private_${root.id}_create`], root.id)"></Switch></td>
            <td class="ccc"><Switch v-model="item.meta[`private_${root.id}_list`]" @update="updateAccess('list', item.meta[`private_${root.id}_list`], root.id)"></Switch></td>
            <td class="ccc"><Switch v-model="item.meta[`private_${root.id}_prices`]" @update="updateAccess('prices', item.meta[`private_${root.id}_prices`], root.id)"></Switch></td>
            <td class="ccc"><Switch v-model="item.meta[`private_${root.id}_brands`]" @update="updateAccess('brands', item.meta[`private_${root.id}_brands`], root.id)"></Switch></td>
          </tr>
        </table>
      </div>
      <br><br>
      
      </div>

      

      <br>

      <!-- <router-view></router-view> -->
    

    </div>
    

    
    <!-- <div class="row ch">
      <div class="column" style="margin-right: 20px;">
        
      </div>
      
    </div> -->
    
    <!-- <h1>Edit user</h1> -->
    <!-- <p class="desc w500">User login depends on what provider you choose.</p> -->
    <div class="column full">

        <!-- provider -->
        <!-- <Block title="Provider" sub="How user have to login with" must>
          <div class="row">
              <p class="tag" :class="{active: newAccount.provider == item.id}" @click="newAccount.provider = item.id" v-for="(item, index) in dict.providers" :key="index">{{ item.title }}</p>
          </div>
        </Block> -->

        <!-- wait provider -->
        

            <!-- email -->
            <!-- <Block  class="w300" title="Email" must>
              <input class="nomargin" type="email" placeholder="some@gmail.com" v-model="newAccount.email">
            </Block> -->
            
            <!-- password -->
            <!-- <Block v-if="newAccount.provider == 2" class="w300" title="Password" sub="Password must be 8 chars lenght" must>        
              <input class="nomargin" type="text" v-model="newAccount.pass">          
            </Block> -->
                  
            <!-- location -->
            <!-- <Block class="w300" title="Location" must>
              <GeoInput v-model="newAccount.geoid" @update="refresh()" placeholder="Location" class="w300 nomargin" height="300px"/>        
            </Block> -->

            <!-- name -->
            <!-- <Block class="w300" title="Name">
              <input class="nomargin" type="text" v-model="newAccount.name">
            </Block> -->

            <!-- active -->
            <!-- <Block class="w300" title="Active" sub="User can login into platform" must>
              <switcher :checked="newAccount.active"  @switch="newAccount.active = !newAccount.active"></switcher>
            </Block> -->

            <!-- verified -->
            <!-- <Block v-if="newAccount.provider == 2" class="w300" title="Verified" sub="User email is verified" must>
              <switcher :checked="newAccount.verified"  @switch="newAccount.verified = !newAccount.verified"></switcher>
            </Block> -->

            <!-- kyc -->
            <!-- <Block class="w300" title="KYC" sub="User is aprooved (Know Your Customer)" must>
              <switcher :checked="newAccount.active"  @switch="newAccount.active = !newAccount.active"></switcher>
            </Block> -->
        

            <!-- kyc -->
            <!-- <Block v-if="errors.length" class="w300">
              <p class="bad" v-for="(item, index) in errors" :key="index" style="color: var(--bad); margin: 4px 0 ;" >• {{ item }}</p>
            </Block> -->
          
            <!-- buttons -->
            <!-- <div class="column">              
                <hr>
                <br>                
                <div class="row"><p class="button" style="margin: 0;" @click="createUser()">Create</p></div>      
                <br><br>
            </div> -->

      </div>



  


      <!-- newAccountDone -->   
      <!-- <Popup v-model="showAccountCreated" style="z-index: 1000000;">
        <template #icon><svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M45 17.5L41.475 13.975L25.625 29.825L29.15 33.35L45 17.5ZM55.6 13.975L29.15 40.425L18.7 30L15.175 33.525L29.15 47.5L59.15 17.5L55.6 13.975ZM1.025 33.525L15 47.5L18.525 43.975L4.575 30L1.025 33.525Z" fill="#2CE833"/></svg></template>
        <template #title>Done!</template>
        <template #line>Account has been created! Now you can find it in accounts list.</template>        
          <div class="row center">
            <p class="button popupButtonColor" @click="createAccountDone()">OK</p>
          </div>
    </Popup> -->



   <!--  <Column class="mainmenu" border width="400px" padding="0px 30px">
        <br>
        <h3>Profile</h3>
        <table>
          <tr v-for="(v, k) in item" :key="k" class="hover">
            <td v-if="k != 'id' && k != 'meta' && k != 'settings'" class="tt bold">{{ k }}</td>
            <td v-if="k != 'id' && k != 'meta' && k != 'settings'" class="tt">  {{ v }}</td>
          </tr>     
        </table>
        <br>
        <h3>Settings</h3>
        <table>          
          <tr v-for="(v, k) in item.settings" :key="k" class="hover">
            <td class="tt bold">{{ k }}</td>
            <td class="tt">  {{ v }}</td>
          </tr>          
        </table>
        
        <br>
        <h3>Meta</h3>
        <table>          
          <tr v-for="(v, k) in item.meta" :key="k" class="hover">
            <td class="tt bold">{{ k }}</td>
            <td class="tt">  {{ v }}</td>
          </tr>          
        </table>
        <gap big></gap>
    </Column> -->

   

    
    
</template>
<script>
import { defineComponent } from 'vue';
export default defineComponent({
  mounted() {  
    this.refresh()    
  },
  props:{
    id: Number,
  },
  data() {
    return {                 
      item:{},           
      page:'main',    
      apitoken:undefined,    
      access:{},      
      
      newpass: undefined
    }
  },
  computed: {
      user(){
        return this.item
      },
      fieldsList(){
        let p = this.item
        var list = []
        if (!p) return []
        for (var k in p){
          let v = p[k]
          var type = 'string'          
          switch (k) {
            case 'active': 
            case 'ban': 
            case 'kyc': 
            case 'verified':  type = 'bool'; break;
            
            case 'badge':
            case 'email':
            case 'username':
            case 'family':
            case 'line':
            case 'name':
            case 'reason':  type = 'string'; break;
            
            case 'provider': type = 'provider'; break;

            default:
              continue;
          }
          list.push({k,v, type})
        }

        list.push({k:'geoid',v:`${p.geoid}: ${p.city}, ${p.state}, ${p.country}`, type:'geoid'})

        list.sort((a, b) => a.type.localeCompare(b.type))


        return list
      },
      private(){
        return this.item.provider == 3
      }
  },
  
  methods: {

    async uploadAvatar(file){
      let f = file[0]
      let link = await this.uploadImage(f)
      console.log(link)
      if (!link) return
      this.update('image', link)
    },

    async uploadImage(file){
        let body = await this.tools.readFileAsBytes(file)
        let res = await this.api.upload.image(body)
        console.log(res)
        if (res.error){
          console.error(res.error)
          this.progress.status = 'Error'
          this.progress.error = `Images upload problem: ${res.error}`
          return
        }
        return res.resp.link //link
    },

   

    // delete user
    async deleteUser(id){      
      let res = await this.api.send('accounts/delete',{id})      
      if (res.error){
        this.error.create = res.error.code + ': '+ res.error.id
        return
      }

      this.refresh()
    },
    
    
    
    // update user
    async update(k,v){    

      console.log('update',k,v)
      // return
      
      let res = await this.api.send('accounts/update',{id: this.item.id,k,v})      
      if (res.error){
        this.error.update = res.error.code + ': '+ res.error.id
        return
      }

      this.refresh()
    },
    
    // update user
    async changeProvider(v){    

       if (confirm(`Do you really want to change login provider? It might cause bad!`)) {
        let res = await this.api.send('accounts/update',{id: this.item.id,k:'provider',v})      
        if (res.error){
          this.error.update = res.error.code + ': '+ res.error.id
          return
        }
        this.refresh()
      }     
      
    },
    
    
    // update acess
    // async updateAccess(k,v,root){    

    //   console.log('update',k,v)
    //   // return
      
    //   let res = await this.api.send('accounts/update/access',{id: this.item.id, root, k,v})      
    //   if (res.error){
    //     this.error.update = res.error.code + ': '+ res.error.id
    //     return
    //   }

    //   this.refresh()
    // },

    async refresh(){      
      let res = await this.api.send('accounts/get', {id: this.id})
      console.log(res)
      if (res.error){
        console.log(res.error)        
        return
      }
      this.item = res.resp
      // if (this.item.provider == 3) this.generateToken()

      // if (this.dev){
      //   this.item.image = 'https://media3.newlookassets.com/i/newlook/871284510M2/girls/girls-clothing/girls-basics/girls-white-square-neck-ribbed-corset-top.jpg?strip=true&qlt=50&w=720'
      // }
    },
    
    


    
  },
});

</script>
<style scoped>

.avatar{
  width: 100px;
  height: 100px;
  border-radius: 200px;
  background: var(--g01);
  border: 0.5px solid var(--g01)
}

</style>